import React from 'react';
import { MessageBlock, Spinner } from 'elmo-elements';
import './errorStyle.scss';

// This is the  fall back UI for FrameContent page
// Need to use error.data to add custom message and status
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Fallback = ({ error }: any) => {
  if (
    (error.status && error.status === 401) ||
    (error.originalStatus && error.originalStatus === 401)
  ) {
    return (
      <div className="error-spinner">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="fallback">
      <MessageBlock>
        <MessageBlock.Header>
          Sorry this page isn't available right now.
        </MessageBlock.Header>
        <br />
        <MessageBlock.Body>
          We're working to fix the problem. Please try again later.
          <br />
          Please contact us if the issue persists.
        </MessageBlock.Body>
      </MessageBlock>
    </div>
  );
};
